import socialData from "../data/social.json";

interface SocialLink {
  name: string;
  url: string;
  icon: string;
}

const links = socialData.socialLinks as SocialLink[];

export default function Footer() {
  return (
    <footer className="border-t border-border py-16">
      <div className="container mx-auto px-6">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-center">
          <p className="u-label text-muted-foreground">
            &copy; {new Date().getFullYear()} Gabriel Nyante
          </p>

          <nav aria-label="Social links" className="flex flex-wrap gap-x-8 gap-y-3">
            {links.map((link) => (
              <a
                key={link.name}
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="u-label text-muted-foreground transition-colors hover:text-primary"
              >
                {link.name}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
}
